// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1_4QU","unreadBadge":"styles_unreadBadge__1ybg7","modalContent":"styles_modalContent__13hMP","modal":"styles_modal__1dK1j"};